import React from 'react';
import './PoliticaPrivacidad.css';

function PoliticaPrivacidad() {
  return (
    <div className="legal-container">
      <h1>Política de Privacidad y Cookies</h1>
      <p>Centro MBZ se compromete a garantizar que tu información personal se encuentre protegida y no se utilice de forma indebida.</p>

      <h2>Responsable del tratamiento</h2>
      <p>
        Centro MBZ<br />
        Email: <a href="mailto:info@centrombz.es">info@centrombz.es</a>
      </p>

      <h2>Finalidad</h2>
      <p>
        Los datos recabados mediante los formularios de contacto se emplean exclusivamente para:
      </p>
      <ul>
        <li>Atender tus consultas.</li>
        <li>Prestar los servicios solicitados.</li>
      </ul>

      <h2>Legitimación</h2>
      <p>
        Tratamos tus datos basándonos en tu consentimiento (art. 6.1 a) del RGPD) otorgado al enviarnos la información.
      </p>

      <h2>Conservación</h2>
      <p>
        Conservaremos tus datos únicamente durante el tiempo necesario para cumplir con las finalidades descritas, y mientras no solicites su supresión.
      </p>

      <h2>Derechos</h2>
      <p>
        Tienes derecho a acceder, rectificar, suprimir, portar y oponerte al tratamiento de tus datos. Para ejercerlos, envía un correo a <a href="mailto:info@centrombz.es">info@centrombz.es</a>.
      </p>

      <h2>Uso de cookies</h2>
      <p>
        Este sitio web utiliza cookies propias y de terceros. Antes de cargar cookies no esenciales, solicitamos tu consentimiento.
      </p>

      <table className="cookies-table">
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Tipo</th>
            <th>Finalidad</th>
            <th>Titular</th>
            <th>Duración</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>PHPSESSID</td>
            <td>Técnica</td>
            <td>Mantener la sesión iniciada</td>
            <td>centrombz.es</td>
            <td>Sesión</td>
          </tr>
          <tr>
            <td>_ga</td>
            <td>Analítica</td>
            <td>Distinguir usuarios</td>
            <td>Google LLC</td>
            <td>2 años</td>
          </tr>
          <tr>
            <td>_gid</td>
            <td>Analítica</td>
            <td>Diferenciar visitantes únicos</td>
            <td>Google LLC</td>
            <td>24 horas</td>
          </tr>
          <br></br>
        </tbody>
      </table>

      <p>
        Puedes gestionar tus preferencias de cookies en cualquier momento haciendo clic en el enlace{' '}
        <a href="/configurar-cookies">"Configuración de cookies"</a> situado en el pie de página.
      </p>

      <h2>Base legal</h2>
      <p>
        El tratamiento de datos personales se realiza conforme al Reglamento (UE) 2016/679 (RGPD) y la Ley Orgánica 3/2018.
      </p>

      <h2>Vigencia y actualizaciones</h2>
      <p>
        Última actualización: 15 de junio de 2025. Esta política podrá actualizarse en cualquier momento; la versión vigente estará siempre publicada en esta página.
      </p>
    </div>
  );
}

export default PoliticaPrivacidad;